import React from "react";
import { useSelector, useDispatch } from "react-redux";
import {
  Paper,
  TextField,
  Typography,
  Stack,
  Divider,
} from "@mui/material";
import { updateOrderdata } from "../../store/slices/wholesaleOrderSlice";
import { constants } from "../../constants";

export default function Discount() {
  const dispatch = useDispatch();
  const orderData = useSelector((state) => state.order);

  const subtotalItems = orderData.order_details.reduce(
    (sum, item) => sum + item.orderQty * item.unitprice,
    0
  );

  // compute tax amount
  const taxedAmount = subtotalItems * (constants.TAX_PERCENTAGE / 100);

  // compute total payable
  const subtotal =
    subtotalItems + taxedAmount - (orderData.discountamount || 0);



  if (!orderData.order_details || orderData.order_details.length === 0) {
    return null;
  }

  return (
    <Paper
      sx={{
        mt: 3,
        p: 3,
        borderRadius: 3,
        boxShadow: 3,
        backgroundColor: "#fafafa",
      }}
    >
      <Typography variant="h6" fontWeight="bold" mb={2}>
        Order Summary
      </Typography>

      {/* Items Subtotal */}
      <Stack direction="row" justifyContent="space-between" mb={1}>
        <Typography>Items Subtotal</Typography>
        <Typography fontWeight="bold">€ {subtotalItems.toFixed(2)}</Typography>
      </Stack>

      {/* Tax */}
      <Stack direction="row" justifyContent="space-between" mb={1}>
        <Typography>
          Tax ({constants.TAX_PERCENTAGE}%)
        </Typography>
        <Typography fontWeight="bold">€ {taxedAmount.toFixed(2)}</Typography>
      </Stack>
    

      {/* Discount / Round Off */}
      <Stack direction="row" justifyContent="space-between" mb={1}>
        <Stack direction="row" spacing={1} alignItems="center">
          <Typography>Round Off</Typography>
          <TextField
            type="number"
            size="small"
            value={orderData.discountamount}
            onChange={(e) =>
              dispatch(
                updateOrderdata({
                  field: "discountamount",
                  value: parseFloat(e.target.value) || 0,
                })
              )
            }
            sx={{
              width: 100,
              "& .MuiInputBase-input": {
                padding: "4px 6px",
                fontSize: "0.8rem",
              },
            }}
          />
        </Stack>
        <Typography fontWeight="bold">
          € {orderData.discountamount || 0}
        </Typography>
      </Stack>

      <Divider sx={{ my: 2 }} />

      {/* Total Payable */}
      <Stack direction="row" justifyContent="space-between">
        <Typography variant="h6" fontWeight="bold">
          Total Payable
        </Typography>
        <Typography variant="h6" fontWeight="bold" color="primary">
          € {subtotal.toFixed(2)}
        </Typography>
      </Stack>
    </Paper>
  );
}
